const facialBiometrics = {
  capture: {
    success: 'Pronto! Conseguimos capturar sua foto!',
  },
};

export default facialBiometrics;
